module.exports = __webpack_public_path__ + "img/ic_close.a56267de.svg";